import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { truncate } from 'lodash/string';

class FestivalNewsCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
      let newsItem = '';
      newsItem = this.props.newsItem;

      let url = '';
      let is_external_link = false;
      let cardMarkup;

      // Test presence of URL
      if (newsItem.lp_url != '') {
        url = newsItem.lp_url;
        is_external_link = true;
      } else if (newsItem.org_detail_url != '') {
        url = newsItem.org_detail_url;
      }


      let thumbnail_text = truncate(newsItem.thumbnail_text,{
        'length': 200,
        'separator': /,? +/
      });

      if (is_external_link) {
        cardMarkup = <a href={url}><div className="featuredOrgCard-innerWrapper">

          <div className="featuredOrgCard-banner">
            <div className="featuredOrgCard-imgFilter"><img src="images/home/shim_featuredOrgs.gif" /></div>
            <div className="featuredOrgCard-img"><img src={newsItem.image_news_banner} /></div>
          </div>

          <div className="featuredOrgCard-body">
            <div className="featuredOrgCard-category">Girls' Festival</div>
            <div className="featuredOrgCard-name">{newsItem.title}</div>
            <div className="featuredOrgCard-copy-wrapper">
              <div className="featuredOrgCard-copy">

                <div className="featuredOrgCard-logo">
                  <img src={newsItem.image_icon} />
                </div>
                {thumbnail_text}
              </div>

            </div>
          </div>

        </div></a>
      } else {
        cardMarkup = <Link to={url}><div className="featuredOrgCard-innerWrapper">

          <div className="featuredOrgCard-banner">
            <div className="featuredOrgCard-imgFilter"><img src="images/home/shim_featuredOrgs.gif" /></div>
            <div className="featuredOrgCard-img"><img src={newsItem.image_news_banner} /></div>
          </div>

          <div className="featuredOrgCard-body">
            <div className="featuredOrgCard-category">Girls' Festival</div>
            <div className="featuredOrgCard-name">{newsItem.title}</div>
            <div className="featuredOrgCard-copy-wrapper">
              <div className="featuredOrgCard-copy">
                <div className="featuredOrgCard-logo">
                  <img src={newsItem.image_icon} />
                </div>

                {thumbnail_text}
              </div>

            </div>
          </div>

        </div></Link>
      }


    return(
      <main>
        <div className="featuredOrgCard">
          {cardMarkup}
        </div>
      </main>

    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps
)(FestivalNewsCard);



// WEBPACK FOOTER //
// ./src/components/festival/news/FestivalNewsCard.jsx